import { render, staticRenderFns } from "./booking_shell.vue?vue&type=template&id=211f88c4&scoped=true&"
import script from "./booking_shell.vue?vue&type=script&lang=js&"
export * from "./booking_shell.vue?vue&type=script&lang=js&"
import style0 from "./booking_shell.vue?vue&type=style&index=0&id=211f88c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f88c4",
  null
  
)

export default component.exports